module.exports = __webpack_public_path__ + "static/media/paper-comeback.fe0767dd.jpg";